module.exports = __webpack_public_path__ + "static/media/card_badge_shape.7c7fe5a1.svg";